import { createSelector } from "reselect";
import { RootState } from "../../rootReducer";

export const selectItemMessages = createSelector(
  [(store: RootState) => store.paymentNoticeDetail.itemMessages],
  (itemMessages) => itemMessages
);
